module.exports = __webpack_public_path__ + "static/feature wall - 1-a7b552afc2d0e8b1c4317b0841233133.jpg";